"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SALES_SUBSTAGE_ORDER = exports.ACCOUNT_LEAD_STATUS_REASONS = exports.SALES_SUBSTAGES_TO_STATUS_REASONS = exports.SALES_STAGES_TO_SALES_STATUS_REASONS = exports.SALES_STATUS_REASONS_TO_STAGE = exports.SALES_STATUS_REASONS_TO_SUBSTAGES = void 0;
const core_1 = require("@newfront-insurance/core");
const types_1 = require("./types");
exports.SALES_STATUS_REASONS_TO_SUBSTAGES = {
    RESET: types_1.SalesSubstage.NEW,
    CREATED: types_1.SalesSubstage.NEW,
    CONTACT_CONFIRMED: types_1.SalesSubstage.CONTACT_CONFIRMED,
    INITIAL_CALL_SCHEDULED: types_1.SalesSubstage.INITIATED,
    OPPORTUNITIES_CONFIRMED: types_1.SalesSubstage.QUALIFIED,
    NEW_BUSINESS_SUBMITTED: types_1.SalesSubstage.ALIGNED,
    QUOTING_PLAN_ASSOCIATED: types_1.SalesSubstage.ALIGNED,
    PL_COLLABORATION_PLAN_SENT: types_1.SalesSubstage.ALIGNED,
    PROPOSAL_DELIVERED: types_1.SalesSubstage.EXECUTED,
    BOUND_POLICY_ASSOCIATED: types_1.SalesSubstage.CLOSED,
};
exports.SALES_STATUS_REASONS_TO_STAGE = {
    RESET: types_1.SalesStage.LEAD,
    CREATED: types_1.SalesStage.LEAD,
    CONTACT_CONFIRMED: types_1.SalesStage.LEAD,
    INITIAL_CALL_SCHEDULED: types_1.SalesStage.LEAD,
    OPPORTUNITIES_CONFIRMED: types_1.SalesStage.LEAD,
    NEW_BUSINESS_SUBMITTED: types_1.SalesStage.PROSPECT,
    QUOTING_PLAN_ASSOCIATED: types_1.SalesStage.PROSPECT,
    PL_COLLABORATION_PLAN_SENT: types_1.SalesStage.PROSPECT,
    PROPOSAL_DELIVERED: types_1.SalesStage.PROSPECT,
    BOUND_POLICY_ASSOCIATED: types_1.SalesStage.CLIENT,
};
exports.SALES_STAGES_TO_SALES_STATUS_REASONS = Object.keys(exports.SALES_STATUS_REASONS_TO_STAGE).reduce((acc, salesStatusReason) => {
    const salesStage = exports.SALES_STATUS_REASONS_TO_STAGE[salesStatusReason];
    return { ...acc, [salesStage]: [...acc[salesStage], salesStatusReason] };
}, { LEAD: [], PROSPECT: [], CLIENT: [] });
exports.SALES_SUBSTAGES_TO_STATUS_REASONS = (0, core_1.toGroupedRecord)(Object.keys(exports.SALES_STATUS_REASONS_TO_SUBSTAGES), (statusReason) => exports.SALES_STATUS_REASONS_TO_SUBSTAGES[statusReason]);
exports.ACCOUNT_LEAD_STATUS_REASONS = [
    types_1.SalesStatusReason.CREATED,
    types_1.SalesStatusReason.CONTACT_CONFIRMED,
    types_1.SalesStatusReason.INITIAL_CALL_SCHEDULED,
    types_1.SalesStatusReason.RESET,
];
/**
 * The higher the value of this record, the more advanced the sales substage in the pipeline will be
 */
exports.SALES_SUBSTAGE_ORDER = {
    NEW: 1,
    CONTACT_CONFIRMED: 2,
    INITIATED: 3,
    QUALIFIED: 4,
    ALIGNED: 5,
    EXECUTED: 6,
    CLOSED: 7,
};
//# sourceMappingURL=util.js.map